import { DatePicker, Space, Typography } from 'antd'
import { ImplicitEnablePanelHeaderProps } from './types'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'

const ImplicitEnablePanelHeader: React.VFC<ImplicitEnablePanelHeaderProps> = ({
  reportType: type,
  effectiveDate,
}) => (
  <Space size="middle" direction="vertical">
    <Typography>
      If a {type} fails any of the enabled checks, use the associated message(s)
      to issue an Identified Field Issue.
    </Typography>
    <CIMSFormItem
      label="Effective Date"
      name="effectiveDate"
      disabled={{
        disabled: !effectiveDate,
        reason: {
          why: 'disabled',
          message: `Cannot edit while ${type} is disabled`,
        },
      }}
      help={HelpMessage.Administration.ProjectSettings.IFITracker.EffectiveDate}
    >
      <DatePicker disabled={!effectiveDate} />
    </CIMSFormItem>
  </Space>
)

export default ImplicitEnablePanelHeader
